// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"27e1f122","4494":"fcc1690c","6280":"fcc1690c","6596":"fcc1690c","6800":"fcc1690c"}[chunkId] + ".chunk.css";
};